// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaiming-cls1_JV2","cls2":"PaperClaiming-cls2_7jg PaperClaiming-cls1_JV2"};